import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';

import { JVInput } from "../../../shared/JVInput";
import { Fetch } from "../../../shared/Fetch";
import { JVDate } from "../../../shared/JVDate";
import { IUsersDropdown, ICompanyMastDropdown, IBranchMastDropdown, ITeamsDropdown, ISkillCategoriesDropdown } from "../../../models/IDropdown";
import { JVDropdown } from "../../../shared/JVDropdown";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../../models/Login";
import { Dropdown } from "primereact/dropdown";
import { POStatus } from "../../../models/PurchaseOrder";
import { PO_Status } from "../../../models/FDropdown";


export interface IFilterPurchase {
    POorStart_Date?: string | null,
    From_Date?: Date | null,
    To_Date?: Date | null,
    Consultant_Name?: string | null,
    Status?: POStatus | null,
    // End_Client?: string | null,
    // Vendor_Company_Name?: string | null,
    // Sub_Vendor_Company?: string | null,
    // Company?: number | null,
    // CompanyType?: string | null,
    // Branch?: number | null,
    // Team_Name?: number | null,
    // SM?: number | null,
    // Recruiter?: number | null,
    // Status?: string | null,
    // s_User_Status?: boolean | null,
    // r_User_Status?: boolean | null,
    // req_Category?: number | null,


}

export const EmptyFilterPurchase: IFilterPurchase = {
    POorStart_Date: null,
    From_Date: null,
    To_Date: null,
    // Req_ID: "",
    Consultant_Name: "",
    // End_Client: "",
    // Vendor_Company_Name: "",
    // Sub_Vendor_Company: "",
    // Company: null,
    // CompanyType: null,
    // Branch: null,
    // Team_Name: null,
    // SM: null,
    // Recruiter: null,
    Status: null,
    // s_User_Status: null,
    // r_User_Status: null,
    // req_Category: null,

}


const schema = yup.object({
    POorStart_Date: yup.string().nullable(),
    From_Date: yup.date().nullable(),
    To_Date: yup.date().nullable(),
    // Req_ID: yup.string().nullable(),
    Consultant_Name: yup.string().nullable(),
    // End_Client: yup.string().nullable(),
    // Vendor_Company_Name: yup.string().nullable(),
    // Sub_Vendor_Company: yup.string().nullable(),
    // Company: yup.string().nullable(),
    // CompanyType: yup.string().nullable(),
    // Branch: yup.string().nullable(),
    // Team_Name: yup.number().nullable(),
    // SM: yup.number().nullable(),
    // Recruiter: yup.string().nullable(),
    Status: yup.number().nullable(),
    // req_Category: yup.number().nullable(),
    // s_User_Status: yup.bool().nullable(),
    // r_User_Status: yup.bool().nullable(),
});

interface Iprops {
    filters: IFilterPurchase,
    setFilters: (filters: IFilterPurchase) => void,
    loadTableData: (filter: any) => void;

}
export const Filter = (props: Iprops) => {

    const [po, setPo] = useState<Array<any>>();
    const [type, setType] = useState<Array<any>>();
    const [consultant, setConsultant] = useState<Array<any>>();
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');


    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IFilterPurchase>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });


    const loadPo = async () => {
        const data = [
            {
                po_Type: "-- SELECT --"
            },
            {
                po_Type: "Start Date"
            },
            {
                po_Type: "PO Date"
            },
            {
                po_Type: "End Date"
            }
        ]

        setPo(data);
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            // if (name === "CompanyType") {
            //     if (value.CompanyType === "recruiter" && value.CompanyType != null) {

            //         loadTeam(control._formValues.Branch, control._formValues.Company, "recruiter");
            //     } else if (value.CompanyType === "sales" && value.CompanyType != null) {

            //         loadTeam(control._formValues.Branch, control._formValues.Company, "sales");
            //     } else {

            //         if (value.CompanyType != null) {
            //             loadTeam(control._formValues.Branch, control._formValues.Company, "");
            //         }
            //     }
            // }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadPo();
        getConsultantName();
    }, []);

    const searchToDB = async (body: IFilterPurchase) => {
        //console.log(body);
        body.Consultant_Name = body.Consultant_Name != null ? body.Consultant_Name.split("(")[0].trim() : null;
        props.setFilters(body);
        props.loadTableData(body);
    }

    const onClear = () => {
        reset(EmptyFilterPurchase);
        loadPo();
    }

    const getConsultantName = async () => {
        const response = await Fetch("DropDown/consultantNameList", "GET", null, `isTimesheet=1`, null);
        if (response) {
            const data: any = await response.json();
            setConsultant(data);
        }
    }

    function onSubmit(data: IFilterPurchase) {
        searchToDB(data);
    }

    return (

        // <Dialog visible={props.open} style={{ width: '80vw' }} header="Search Requirement" modal className="p-fluid" onHide={onHide}>
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

            <JVDropdown column={6} label="PO/Start Date " control={control} name="POorStart_Date" options={po} optionLabel="po_Type" optionValue="po_Type" placeholder="Select PO " />
            <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="From_Date" />
            <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="To_Date" />
            <JVDropdown column={6} label="Status " control={control} name="Status" options={PO_Status} optionLabel="name" optionValue="id" placeholder="Select Status " />
            {/* <JVInput column={6} label="Consultant Name" type="text" control={control} name="Consultant_Name" /> */}
            <JVDropdown column={6} label="Consultant Name " filter control={control} name="Consultant_Name" options={consultant} optionLabel="consultant_Name" optionValue="consultant_Name" placeholder="Select Consultant " />

            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
            </div>
        </form>

    )
}